import React from "react";
import Grid from "@material-ui/core/Grid";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Accordion } from "@material-ui/core";

import { StyledFieldset, StyledAccordion } from "./styles/Fieldset";

const Fieldset = ({
  children,
  titulo,
  bgcolor = "primary",
  textcolor = "white",
  accordion = false,
  defaultExpanded = true,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid key={`grid_fieldset_item_${titulo}`} item xs={12}>
        {accordion ? (
          <StyledAccordion bgcolor={bgcolor} textcolor={textcolor}>
            <Accordion defaultExpanded={defaultExpanded}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-pesquisa"
                id="panel-pesquisa"
              >
                <legend>{titulo}</legend>
              </AccordionSummary>
              <AccordionDetails> {children}</AccordionDetails>
            </Accordion>
          </StyledAccordion>
        ) : (
          <StyledFieldset bgcolor={bgcolor} textcolor={textcolor}>
            <legend>{titulo}</legend>
            {children}
          </StyledFieldset>
        )}
      </Grid>
    </Grid>
  );
};

export default Fieldset;
